import React from 'react'
import { oneOf } from 'prop-types'
import { Box, Icon, Tooltip } from '@planningcenter/tapestry-react'
import { ThemeProvider } from './ThemeProvider'

export default function ApplicationTypeIndicator({ type = 'confidential' }) {
  const applicationType = {
    confidential: {
      icon: 'general.lock',
      label: 'Confidential application',
    },
    public: {
      icon: 'churchCenter.globe',
      label: 'Public application',
    },
  }[type]

  return (
    <ThemeProvider>
      <Box backgroundColor="grey-2" padding={0.75} borderRadius="100%">
        <Tooltip title={applicationType.label} placement="top" openDelay={0}>
          <Icon name={applicationType.icon} size="md" color="grey-8"></Icon>
        </Tooltip>
      </Box>
    </ThemeProvider>
  )
}

ApplicationTypeIndicator.propTypes = {
  status: oneOf(['public', 'confidential']).isRequired,
}
